// ABOUTME: Header actions for a configuration entity view — Export (download bundle) and Import (open dialog).
import {Button, Icon} from '@hm/fundamental'
import {mdiTrayArrowDown, mdiTrayArrowUp} from '@mdi/js'
import React, {useState} from 'react'
import {useSnackbar} from 'notistack'

import {ConfigImportDialog} from './ConfigImportDialog'
import {useTranslation} from '../../../../hooks/useTranslation'
import {useExportConfig} from '../hooks/useConfigImportExport'
import {EntityType} from '../types'

interface ConfigImportExportActionsProps {
  entityType: EntityType
  entityName: string
  countryId: string
  businessLine: string
}

export const ConfigImportExportActions: React.FC<ConfigImportExportActionsProps> = ({
  entityType,
  entityName,
  countryId,
  businessLine
}) => {
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar()
  const exportConfig = useExportConfig()
  const [importOpen, setImportOpen] = useState(false)

  const handleExport = async () => {
    try {
      await exportConfig.mutateAsync({entityType, countryId, businessLine})
    } catch {
      enqueueSnackbar(t('countryConfigurations.importExport.exportError'), {
        variant: 'error',
        anchorOrigin: {vertical: 'top', horizontal: 'center'}
      })
    }
  }

  return (
    <>
      <Button
        variant="secondary"
        type="button"
        onClick={handleExport}
        disabled={exportConfig.isPending}
        aria-label={t('countryConfigurations.importExport.exportButton')}
      >
        <Icon path={mdiTrayArrowDown} size="regular" />
        {t('countryConfigurations.importExport.exportButton')}
      </Button>
      <Button
        variant="secondary"
        type="button"
        onClick={() => setImportOpen(true)}
        aria-label={t('countryConfigurations.importExport.importButton')}
      >
        <Icon path={mdiTrayArrowUp} size="regular" />
        {t('countryConfigurations.importExport.importButton')}
      </Button>
      <ConfigImportDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
        entityType={entityType}
        entityName={entityName}
        countryId={countryId}
        businessLine={businessLine}
      />
    </>
  )
}
